export const Sidebarmenu = [
    {
        to: "/employee-dashboard", id: '{"data": "dashboard_li"}', Name: "Dashboard", icon: "srkay-dashboard", checkPath: "/dashboard /developer-dashboard /employee-dashboard /lead-dashboard /inspectra",
        innerMenu: [
            {
                to: "/employee-dashboard", id: '{"data": "dashboard_tab"}', Name: "Dashboard", icon: "srkay-home",
                subMenu: [{ to: "/developer-dashboard", id: '{"data": "dashboard_tab"}', Name: "Developer Dashboard", icon: "srkay-laptop-2" },]
            },
            { to: "/employee-dashboard", id: '{"data": "employee_dashboard_tab"}', Name: "Employee Dashboard", icon: "srkay-user-admin" },
            { to: "/lead-dashboard", id: '{"data": "manager_dashboard_tab"}', Name: "Lead Dashboard", icon: "srkay-widget" },
            { to: "/inspectra", id: '{"data": "inspectra_dashboard_tab"}', Name: "Inspectra Dashboard", icon: "srkay-eye" }
        ]
    },
    {
        to: "/employee-attendance", state: { key: "attendance" }, id: '{"data": "hr_lens_li"}', Name: "HR Lens", icon: "icon-hr_lens-outline", checkPath: "/employee-attendance /punch-report /punctuality-report /regularization-list /events",
        innerMenu: [
            {
                to: "/employee-attendance", state: { key: "attendance" }, id: '{"data": "employee_attendance_tab"}', Name: "Attendance", icon: "srkay-notebook",
                subMenu: [
                    { to: "/employee-attendance", state: { key: "attendance" }, id: '{"data": "employee_attendance_tab"}', Name: "Employee Attendance", icon: "srkay-user-admin" },
                    { to: "/punch-report", state: { key: "punch" }, id: '{"data": "employee_attendance_tab"}', Name: "Punch Report", icon: "srkay-time-meter" },
                    { to: "/events", checkPath: "Setting", id: '{"data": "event_tab"}', Name: "Events", icon: "srkay-flag" }
                ]
            },
            { to: "/punctuality-report", id: '{"data": "punctuality_report_tab"}', Name: "Punctuality", icon: "srkay-watch-round" },
            { to: "/regularization-list", id: '{"data": "regularization_tab"}', Name: "Regularization", icon: "srkay-list" }
        ]
    },
    {
        to: "/timesheet", state: { team: "details" }, id: '{"data": "timesheet_li"}', checkPath: "/timesheet /timesheet-summary /timesheet-chart /project-timesheet-details /timesheet-request-list", Name: "Timesheet", icon: "icon-timesheet-outline",
        innerMenu: [
            {
                to: "/timesheet", state: { team: "details" }, id: '{"data": "manager_timesheet_details_tab"}', Name: "Timesheets", icon: "srkay-file",
                subMenu: [
                    { to: "/timesheet", state: { team: "details" }, id: '{"data": "manager_timesheet_details_tab"}', Name: "Timesheet Details", icon: "srkay-info-circle" },
                    { to: "/timesheet-summary", state: { team: "summary" }, id: '{"data": "manager_timesheet_summary_tab"}', Name: "Timesheet Summary", icon: "srkay-task-list" },
                    { to: "/timesheet-chart", state: { team: "chart" }, id: '{"data": "manager_timesheet_chart_tab"}', Name: "Timesheet Chart", icon: "srkay-diagram-up" }
                ]
            },
            { to: "/project-timesheet-details", id: '{"data": "project_timesheet_details_tab"}', Name: "Project Timesheet Details", icon: "srkay-notebook" },
            { to: "/timesheet-request-list", id: '{"data": "timesheet_extend_request_tab"}', Name: "Request List", icon: "srkay-letter" }
        ]
    },
    {
        to: "/project-highlight", id: '{"data": "project_highlight_li"}', checkPath: "/project-highlight-dashboard /project-highlight /client-highlight /project-glance /help-desk-project-access", Name: "Project Highlight", icon: "icon-project-outline",
        innerMenu: [
            {
                to: "/project-highlight", id: '{"data": "project_highlight_tab"}', Name: "Highlights", icon: "srkay-star",
                subMenu: [
                    { to: "/project-highlight", id: '{"data": "project_highlight_tab"}', Name: "Project Highlight", icon: "srkay-star" },
                    { to: "/project-highlight-dashboard", id: '{"data": "project_dashboard_tab"}', Name: "Project Dashboard", icon: "srkay-home" },
                    { to: "/client-highlight", id: '{"data": "client_highlight_tab"}', Name: "Client Highlight", icon: "srkay-globus" }
                ]
            },
            { to: "/project-glance", id: '{"data": "project_glance_tab"}', Name: "Project Glance", icon: "srkay-eye" },
            { to: "/help-desk-project-access", id: '{"data": "project_access_tab"}', Name: "Project Access", icon: "srkay-key" }
        ]
    },
    {
        to: "/team-list", state: { team: "team-list" }, checkPath: "/capacity-tracker /team-overview /team-list /chart-config /nine-box /evaluate-list /precision-entry /precision-report /resource-request /profile-request /awards /nodes", id: '{"data": "team_li"}', Name: "Team", arrowKey: "team", icon: "icon-team_group-outline",
        innerMenu: [
            {
                to: "/team-list", state: { team: "team-list" }, id: '{"data": "team_list_tab"}', Name: "Team Info", icon: "srkay-widget",
                subMenu: [
                    { to: "/team-list", state: { team: "team-list" }, id: '{"data": "team_list_tab"}', Name: "Team List", icon: "srkay-user-admin" },
                    { to: "/chart-config", state: { team: "chart-config" }, id: '{"data": "chart_config_tab"}', Name: "Chart Config", icon: "srkay-tuning-2" }
                ]
            },
            {
                to: "/precision-entry", id: '{"data": "precision_entry_tab"}', Name: "Precision", icon: "srkay-verified-check",
                subMenu: [
                    { to: "/precision-entry", id: '{"data": "precision_entry_tab"}', Name: "Precision Entry", icon: "srkay-edit-2" },
                    { to: "/precision-report", id: '{"data": "precision_report_tab"}', Name: "Precision Report", icon: "srkay-graph-up" }
                ]
            },
            { to: "/evaluate-list", id: '{"data": "evaluate_tab"}', Name: "Evaluate List", icon: "srkay-list" },
            { to: "/nine-box", id: '{"data": "9box_li"}', Name: "9 Box", icon: "srkay-widget" },
            {
                to: "/resource-request", id: '{"tabname": "team_li", "data": "resource_request_tab"}', Name: "Requests", icon: "srkay-letter",
                subMenu: [
                    { to: "/resource-request", id: '{"tabname": "team_li", "data": "resource_request_tab"}', Name: "Resource Request", icon: "srkay-user-admin" },
                    { to: "/profile-request", id: '{"tabname": "team_li", "data": "profile_request_tab"}', Name: "Profile Request", icon: "srkay-user-admin" },
                     { to: "/awards", id: '{"data": "awards_tab"}', Name: "Awards",icon: "srkay-user-admin" }
                ]
            }
        ]
    },
    {
        to: "/planning", id: '{"data": "agileplanning_li"}', checkPath: "/bucket-summary /bucket-planning /estimate /review-game /declare-game /bucket-list /agile-kanban /estimating /declaring /reviewing /planning /bucket-configration /my-bucket /task-list /time-matrix", Name: "Agile Planning", arrowKey: "agile", icon: "icon-agile_planning-outline",
        innerMenu: [
            {
                to: "/planning", id: '{"data": "agileplanning_bucket_planning_tab"}', Name: "Planning", icon: "srkay-calendar",
                subMenu: [
                    { to: "/planning", id: '{"data": "agileplanning_bucket_planning_tab"}', Name: "Planning Board", icon: "srkay-calendar" },
                    { to: "/agile-kanban", id: '{"data": "agileplanning_kanban_board_tab"}', Name: "Kanban Board", icon: "srkay-list" }
                ]
            },
            {
                to: "/estimating", id: '{"data": "agileplanning_estimation_tab"}', Name: " Estimating", icon: "srkay-notebook",
                subMenu: [
                    { to: "/estimating", id: '{"data": "agileplanning_estimation_tab"}', Name: "Estimating", icon: "srkay-notebook" },
                    { to: "/my-bucket", id: '{"data": "agileplanning_estimation_tab"}', Name: "My Bucket", icon: "srkay-download" }
                ]
            },
            {
                to: "/declaring", id: '{"data": "agileplanning_declare_tab"}', Name: "Declare", icon: "srkay-flag",
                subMenu: [
                    { to: "/declaring", id: '{"data": "agileplanning_declare_tab"}', Name: "Declare", icon: "srkay-flag" },
                    { to: "/reviewing", id: '{"data": "agileplanning_review_tab"}', Name: "Reviewing", icon: "srkay-clipboard-list" }
                ]
            },
            { to: "/task-list", id: '{"data": "task_list_tab"}', Name: "Task List", icon: "srkay-task-list" },
            {
                to: "/bucket-configration", id: '{"data": "agileplanning_bucket_configration"}', Name: "Configuration", icon: "srkay-tuning-2",
                subMenu: [
                    { to: "/bucket-configration", id: '{"data": "agileplanning_bucket_configration"}', Name: "Bucket Config", icon: "srkay-tuning-2" },
                    { to: "/time-matrix", id: '{"data": "time_matrix_tab"}', Name: "Time Matrix Config", icon: "srkay-time-meter" }
                ]
            }
        ]
    },
    {
        to: "/screens", id: '{"data": "task_layout_li"}', Name: "Task Layout", icon: "icon-dashboard-outline", checkPath: "/fields /screens /priorities /task-type-hierarchy /task-status",
        innerMenu: [
            {
                to: "/screens", id: '{"data": "screen_tab"}', Name: "Layout Config", icon: "srkay-laptop-2",
                subMenu: [
                    { to: "/screens", id: '{"data": "screen_tab"}', Name: "Screens", icon: "srkay-laptop-minimalistic" },
                    { to: "/fields", id: '{"data": "field_tab"}', Name: "Fields", icon: "srkay-file" },
                    { to: "/priorities", id: '{"data": "priority_tab"}', Name: "Priorities", icon: "srkay-list" },
                    { to: "/task-type-hierarchy", id: '{"data": "task_type_hierarchy_tab"}', Name: "Task Type Hierarchy", icon: "srkay-folder" },
                    { to: "/task-status", id: '{"data": "task_status_tab"}', Name: "Task Status", icon: "srkay-history" }
                ]
            }
        ]
    },
    {
        to: "/precision-matrix", id: '{"data": "talent_matrix_li"}', Name: "Talent Matrix", icon: "srkay-user-admin", checkPath: "/precision-matrix /agile-matrix",
        innerMenu: [
            { to: "/precision-matrix", id: '{"data": "precision_matrix_tab"}', Name: "Precision Matrix", icon: "srkay-database" },
            { to: "/agile-matrix", id: '{"data": "agile_matrix_tab"}', Name: "Agile Matrix", icon: "srkay-database" }
        ]
    },
    {
        to: "/invoicing", id: '{"data": "invoicing_li"}', Name: "Invoicing", icon: "srkay-document", checkPath: "/invoicing",
        innerMenu: [
            { to: "/invoicing", id: '{"data": "invoicing_li"}', Name: "Invoicing", icon: "srkay-wallet" }
        ]
    },
    {
        to: "/static-report", id: '{"data": "report_li"}', checkPath: "/static-report /dynamic-report /service-desk-report ", Name: "Reports", icon: "icon-report-outline",
        innerMenu: [
            {
                to: "/static-report", id: '{"data": "static_report_tab"}', Name: "Reports", icon: "srkay-database",
                subMenu: [
                    { to: "/static-report", id: '{"data": "static_report_tab"}', Name: "Static Report", icon: "srkay-file" },
                    { to: "/dynamic-report", id: '{"data": "dynamic_report_tab"}', Name: "Dynamic Report", icon: "srkay-file" }
                ]
            },
            { to: "/service-desk-report", id: '{"data": "service_report_tab"}', Name: "Service Desk", icon: "srkay-phone" }
        ]
    },
    {
        to: "/gate-pass", id: '{"data": "gatepass_li"}', checkPath: "/guest-list /outpass-entry /gatekeeper /cabin-booking", Name: "Gate Pass", icon: "icon-gatepass-outline",
        innerMenu: [
            {
                to: "/gate-pass", id: '{"data": "gatepass_gatekeeper_tab"}', Name: "Panel", icon: "srkay-lock",
                subMenu: [
                    { to: "/gatekeeper", id: '{"data": "gatepass_gatekeeper_tab"}', Name: "Gatekeeper Panel", icon: "srkay-lock" },
                    { to: "/guest-list", id: '{"data": "guestlist_tab"}', Name: "Guest List", icon: "srkay-user-admin" },
                    { to: "/outpass-entry", id: '{"data": "gatepass_outpass_entry_tab"}', Name: "Outpass Entry", icon: "srkay-logout" },

                ]
            },

            { to: "/cabin-booking", id: '{"data": "cabin_li"}', Name: "Cabin Booking", icon: "srkay-calendar-add" }
        ]
    },
    {
        to: "/survey", id: '{"data": "survey_li"}', checkPath: "/survey /question-bank /survey-evaluate-list /survey-response", Name: "Survey", icon: "icon-survey-outline",
        innerMenu: [
            {
                to: "/survey", id: '{"data": "survey_tab"}', Name: "Surveys", icon: "srkay-file",
                subMenu: [
                    { to: "/survey", id: '{"data": "survey_tab"}', Name: "Survey List", icon: "srkay-file" },
                    { to: "/survey-response", id: '{"data": "survey_tab"}', Name: "Survey Response", icon: "srkay-file" }
                ]
            },
            { to: "/question-bank", id: '{"data": "question_bank_tab"}', Name: "Questions List", icon: "srkay-info-circle" },
            { to: "/survey-evaluate-list", id: '{"data": "evaluate_tab"}', Name: "Evaluate List", icon: "srkay-list" }
        ]
    },
    {
        to: "/exam-planning", id: '{"data": "exam_planning_li"}', checkPath: "/exam-planning", Name: "Exam Planning", icon: "icon-exam_planning-outline",
        innerMenu: [
            { to: "/exam-planning", id: '{"data": "exam_planning_li"}', Name: "Exam Planning", icon: "srkay-notebook" }
        ]
    },
    {
        to: "/inventory-dashboard", id: '{"data": "inventory_li"}', Name: "Inventory", icon: "srkay-card", checkPath: " /inventory-dashboard /manage-assets /device-dashboard",
        innerMenu: [
            {
                to: "/inventory-dashboard", id: '{"data": "inventory_dashboard_tab"}', Name: "Inventory", icon: "srkay-wallet",
                subMenu: [
                    { to: "/inventory-dashboard", id: '{"data": "inventory_dashboard_tab"}', Name: "Inventory Dashboard", icon: "srkay-wallet" },
                    { to: "/manage-assets", id: '{"data": "inventory_dashboard_tab"}', Name: "Manage Assets", icon: "srkay-laptop-minimalistic" },
                    { to: "/device-dashboard", id: '{ "data": "device_dashboard_tab"}', Name: "Device Request", icon: "srkay-laptop-2" }
                ]
            }
        ]
    },
    {
        to: "/universal-helpdesk", id: '{"data": "helpdesk_li"}', Name: "Help Desk", icon: "icon-helpdesk-outline", checkPath: "/universal-helpdesk /help-desk-git /help-desk-vpn /help-desk-jenkins /help-desk-prod-build /help-desk-prod-server /server-db-master /help-desk-logs",
        innerMenu: [
            {
                to: "/universal-helpdesk", id: '{"data": "universal_helpdesk_tab"}', Name: "Universal Helpdesk", icon: "srkay-info-circle"
            },
            {
                to: "/help-desk-git", id: '{"data": "git_tab"}', key: 'DevOps', Name: "Service Desk", icon: "srkay-letter",
                subMenu: [
                    { to: "/help-desk-git", id: '{"data": "git_tab"}', Name: "Git", icon: "srkay-globus" },
                    { to: "/help-desk-vpn", id: '{"data": "vpn_tab"}', Name: "Vpn", icon: "srkay-lock" },
                    { to: "/help-desk-jenkins", id: '{"data": "jenkins_tab"}', Name: "Jenkins", icon: "srkay-widget" },
                    { to: "/help-desk-prod-build", id: '{"data": "prod_service_build_tab"}', Name: "Production Build", icon: "srkay-folder" }
                ]
            },
            {
                to: "/help-desk-prod-server", id: '{"data": "server_access_tab"}', Name: "Data Desk", icon: "srkay-server",
                subMenu: [
                    { to: "/help-desk-prod-server", id: '{"data": "server_access_tab"}', Name: "Server Access", icon: "srkay-server" },
                    { to: "/server-db-master", checkPath: "Setting", Name: "Server Access Config", id: '{"data":"server_db_master_tab"}', icon: "srkay-tuning-2" },
                    { to: "/help-desk-logs", id: '{"data": "logs_tab"}', Name: "Logs", icon: "srkay-list" }
                ]
            }
        ]
    },
    {
        to: "/welcome-kit", id: '{"data": "welcomekit_li"}', checkPath: "/code-of-conduct-list /code-of-conduct /welcome-kit/welcome-kit-list", Name: "Welcome Kit", arrowKey: "Welcome Kit", icon: "icon-welcome_kit-outline",
        innerMenu: [
            {
                to: "/code-of-conduct", id: '{ "data": "code_of_conduct_tab"}', Name: "Conduct", icon: "srkay-notebook",
                subMenu: [
                    { to: "/code-of-conduct", id: '{ "data": "code_of_conduct_tab"}', Name: "Code of Conduct", icon: "srkay-notebook" },
                    { to: "/code-of-conduct-list", id: '{ "data": "code_of_conduct_list_tab"}', Name: "Code of Conduct List", icon: "srkay-list" }
                ]
            },
            {
                to: "/welcome-kit", id: '{ "data": "welcomekit_li"}', key: 'Welcome Kit', Name: "Kit", icon: "srkay-gift",
                subMenu: [
                    { to: "/welcome-kit", id: '{ "data": "welcomekit_li"}', key: 'Welcome Kit', Name: "Welcome Kit", icon: "srkay-gift" },
                    { to: "/welcome-kit-list", id: '{ "data": "welcomekit_list"}', key: 'Welcome kit list', Name: "Welcome Kit List", icon: "srkay-list" }
                ]
            }
        ]
    },
    {
        to: "/broadcast", id: '{"data": "settings_li"}', checkPath: "/broadcast /control-center /caregory-control-center /master-configuration /holiday-calender /import-status /import-data /history /events /issue-type-hierarchy /cipher /general-setting /experience-center", Name: "Settings", arrowKey: "setting", icon: "icon-setting-outline",
        innerMenu: [
            { to: "/broadcast", checkPath: "Setting", id: '{"data": "broadcast_tab"}', Name: "Broadcast", icon: "srkay-letter" },
            {
                to: "/control-center", checkPath: "Setting", id: '{"data": "control_center_tab"}', Name: "Control Centre", icon: "srkay-sliders",
                subMenu: [
                    { to: "/control-center", checkPath: "Setting", id: '{"data": "control_center_tab"}', Name: "Control Center", icon: "srkay-sliders" },
                    { to: "/caregory-control-center", checkPath: "Setting", id: '{"data": "controlcenter_category_permission_tab"}', Name: "Category Control Center", icon: "srkay-link" }
                ]
            },
            {
                to: "/master-configuration", checkPath: "Setting", id: '{"data": "master_configuration_tab"}', Name: "Master Config", icon: "srkay-gear",
                subMenu: [
                    { to: "/master-configuration", checkPath: "Setting", id: '{"data": "master_configuration_tab"}', Name: "Master Configuration", icon: "srkay-gear" },
                    { to: "/general-setting", checkPath: "Setting", id: '{"data": "general_configuration_tab"}', Name: "General Setting", icon: "srkay-watch-round" }
                ]
            },
            {
                to: "/issue-type-hierarchy", id: '{"data": "issue_type_hierarchy_tab"}', Name: "Workflow Config", icon: "srkay-folder",
                subMenu: [
                    { to: "/issue-type-hierarchy", id: '{"data": "issue_type_hierarchy_tab"}', Name: "Issue Type Hierarchy", icon: "srkay-folder" }
                ]
            },
            {
                to: "/holiday-calender", checkPath: "Setting", id: '{"data": "holiday_calendar_tab"}', Name: "System", icon: "srkay-notebook",
                subMenu: [
                    { to: "/holiday-calender", checkPath: "Setting", id: '{"data": "holiday_calendar_tab"}', Name: "Calendar", icon: "srkay-notebook" },

                ]
            },
            {
                to: "/import-status", checkPath: "Setting", id: '{"data": "import_status_tab"}', Name: "Data", icon: "srkay-database",
                subMenu: [
                    { to: "/import-status", checkPath: "Setting", id: '{"data": "import_status_tab"}', Name: "Import Status", icon: "srkay-list" },
                    { to: "/import-data", checkPath: "Setting", id: '{"data": "import_data_tab"}', Name: "Import Data", icon: "srkay-download" },
                    { to: "/history", checkPath: "Setting", id: '{"data": "history_tab"}', Name: "History Data", icon: "srkay-history" }
                ]
            },
            {
                to: "/cipher", checkPath: "Setting", id: '{"data": "cipher_tab"}', Name: "Tools", icon: "srkay-lock",
                subMenu: [
                    { to: "/cipher", checkPath: "Setting", id: '{"data": "cipher_tab"}', Name: "Cipher", icon: "srkay-lock" }
                ]
            },
            {
                to: "/experience-center", checkPath: "Setting", id: '{"data": "experience_center_tab"}', Name: "Experience Center", icon: "srkay-sliders"
            }
        ]
    }
];